// Site-wide content shared by the header, footer and pages
export const SITE = {
  name: 'Turn10 Racing',
  founder: 'Saverio H Striglia III',
  location: 'Palm City, FL',
  established: 2024,
  // TODO: switch to webcontact@turn10racing.com once the mailbox is set up
  contactEmail: 'saverio@striglia.net',
  instagramUrl: 'https://www.instagram.com/strigs_racer',
  instagramHandle: '@strigs_racer',
};

export const NAV_LINKS = [
  { title: 'Home', to: '/' },
  { title: 'About Us', to: '/about' },
  { title: 'Driver Training', to: '/driver-training' },
  { title: 'WRL 2026', to: '/wrl-2026' },
  { title: 'Gallery', to: '/gallery' },
  { title: 'Contact', to: '/contact' },
];

export const WRL_2026_TRACKS = [
  'Barber Motorsports Park',
  'Road America',
  'Daytona',
  'Road Atlanta',
  'Watkins Glen',
  'Sebring',
  'COTA',
];
